import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { Dropdown } from 'semantic-ui-react'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import { FarmersQuery } from '~/QueryHooks/Farmers'

const MilkDeliveries: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()

  const [dataFiltered, setDataFiltered] = useState({
    rows: 10,
    page: 0,
    date: ''
  })

  const tableColumnHeaders = [
    {
      name: t('Tour data id'),
      key: 'uniqueId'
    },
    {
      name: t('Date start'),
      type: 'date',
      format: 'DD.MM.YYYY HH:mm',
      key: 'date'
    },
    {
      name: t('Date end'),
      type: 'date',
      format: 'DD.MM.YYYY HH:mm',
      key: 'dateEnd'
    },
    {
      name: t('Amount accepted (in l)'),
      key: 'amount',
      type: 'no-unit-number',
      decimalScale: 0
    },
    {
      name: t('Time from'),
      key: 'timeFrom'
    },
    {
      name: t('Time to'),
      key: 'timeTo'
    },
    {
      name: t('Supplier No.'),
      key: 'supplierNo',
      type: 'supplier-link'
    },
    {
      name: t('Amount accepted (in l)'),
      key: 'amount',
      type: 'no-unit-number',
      decimalScale: 0
    },
    {
      name: t('avg. Temp. (°C)'),
      key: 'avgTemp',
      type: 'no-unit-number',
      decimalScale: 1
    },
    {
      name: t('Sample bottle'),
      key: 'sampleBottleNumber'
    },
    {
      name: t('Sample Compartment Temp (°C)'),
      key: 'sampleAvgTemp',
      type: 'no-unit-number',
      decimalScale: 1
    }
  ]

  const {
    data: milkDeliveries,
    isLoading: isLoadingMilkDel,
    isFetching: isFetchingMilkDel,
    refetch: fetchMilkDel
  } = FarmersQuery.getMilkDeliveries(id, {
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  }, dataFiltered.date !== '')

  const {
    data: milkDelData,
    isLoading: isLoadingMilkDelData,
    refetch: fetchMilkDelData
  } = FarmersQuery.getMilkDeliveriesData(id)

  useEffect(() => {
    fetchMilkDel()
    fetchMilkDelData()
  }, [t])

  useEffect(() => {
    fetchMilkDel()
  }, [dataFiltered])

  useEffect(() => {
    if (milkDelData && !dataFiltered.date) {
      setDataFiltered({
        ...dataFiltered,
        date: milkDelData?.months[0]?.key
      })
    }
  }, [milkDelData])

  function renderMonthFilter() {
    return <>
      <Dropdown
        selectOnBlur={false}
        placeholder={t('Select date')}
        selection
        options={milkDelData?.months?.map(month => ({ text: month.label, value: month.key })) || []}
        value={dataFiltered.date}
        onChange={(_, { value }) => {
          setDataFiltered({
            ...dataFiltered,
            date: value as string
          })
        }}
      />
    </>
  }

  function renderTable() {
    return <TableComponent
      isFetchingData={isFetchingMilkDel}
      animated
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      rows={rows}
      total={filtered}
    />
  }

  const { filtered, rows } = milkDeliveries ? milkDeliveries : { filtered: 0, rows: [] };

  return <Layout
    title={t('Milk Deliveries')}
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    filters={renderMonthFilter()}
    useSpinner
    isBusy={isLoadingMilkDel || isLoadingMilkDelData}
  >
    {renderTable()}
  </Layout>
}
export default MilkDeliveries